import Clarity from "@microsoft/clarity";

export default function useMicrosoftClarity() {
	const config = useRuntimeConfig();

	if (import.meta.server) return;
	if (!config.public.microsoftClarityId) return;

	Clarity.init(config.public.microsoftClarityId);
	return true;
}
